module.exports = __webpack_public_path__ + "icons/original/large/large-c1.cf85c5eb9acce5553a85122616f8f7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-c1.png
// module id = +bsQ
// module chunks = app